// @ts-nocheck
export const prefixClassNames = '';
export const initialStatePageKey = 'MembershipType';
export const CUSTOM_MEMBERSHIP_LANDING_PAGE_NAME = 'Custom Membership Landing';
export const CYBER_INTERBANK_PAGE_KEY = '';
